import './components/colourSwitcher.js';
import './components/popups.js';
import './components/burger.js';
import './components/cardScroller.js';
import './components/artworkGrid.js';
import './components/paginationScroll.js';
import './components/heroVideo.js';
import './components/readMore.js';
import './components/copyToClipboard.js';
import './components/smallCaps.js';
import './components/stickyImage.js';

document.querySelector('html').classList.add('js');
